/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { UpdateInquiryTaskCollectionDayMutation, UpdateInquiryTaskCollectionDayMutationVariables } from "@models/graphql";

const defaultUpdateInquiryTaskCollectionDayOptions: MutationHookOptions<UpdateInquiryTaskCollectionDayMutation, UpdateInquiryTaskCollectionDayMutationVariables> = {

};

export const useUpdateInquiryTaskCollectionDay = (options?: MutationHookOptions<UpdateInquiryTaskCollectionDayMutation, UpdateInquiryTaskCollectionDayMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<UpdateInquiryTaskCollectionDayMutation, UpdateInquiryTaskCollectionDayMutationVariables>(GraphQLDocuments.updateInquiryTaskCollectionDay);

    const updateInquiryTaskCollectionDay = async (variables: UpdateInquiryTaskCollectionDayMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultUpdateInquiryTaskCollectionDayOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        updateInquiryTaskCollectionDay
    };
};
